import React from 'react'
import GroundingConfirmModal from './GroundingConfirmModal'
import { useGlobalStore } from 'store/useGlobalStore'

interface IProps {
  show: boolean
  setShowTerms: (data: boolean) => void
}

const TermsModal = ({ show, setShowTerms }: IProps) => {
  const [getLocalText] = useGlobalStore((state) => [state.getLocalText])
  const termsLink = getLocalText('termsLink', 'termsLink')
  const termsText = getLocalText('termsText', 'termsText')

  function unescapeHTML(htmlString) {
    var doc = new DOMParser().parseFromString(htmlString, 'text/html')
    return doc.documentElement.textContent
  }

  return (
    <GroundingConfirmModal
      content={unescapeHTML(termsText)}
      show={show}
      header={termsLink}
      isShowHeader={true}
      isShowButton={false}
      isEmbedHtml={true}
      isBackdropStatic={false}
      events={{
        handleClickXButton: () => setShowTerms(false)
      }}
    />
  )
}

export default TermsModal
